<template>
  <div class="auth-page-container">
    <h2 class="auth-page-title font-500">
      {{ $t('pagelayout.nominal-transaction') }}
    </h2>
    <section class="auth-page-section">
      <b-form v-show="true" @submit.prevent="search" class="mx-2">
        <b-row>
          <div class="col">
            <div class="row mb-ten">
              <date-picker
                :max-date="new Date()"
                @change="dateChange"
                range
                :datesProp="initialDates"
                class="mr-3"
              />
              <ic-button size="tn" type="submit" class="card-button mt-0">
                {{ $t('helper.search') }}
              </ic-button>
            </div>
          </div>
          <div class="col-md-auto">
            <div class="row">
              <ic-button
                size="tn"
                @click="printTransaction"
                type="button"
                color="secondary"
                class="grey"
              >
                <!-- <i class="fas fa-download mr-2" /> -->
                {{ $t('helper.save') }}
              </ic-button>
            </div>
          </div>
        </b-row>
      </b-form>
      <div class="table-container">
        <table class="ic-table">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t('trade.date') }}</th>
              <th class="right">{{ $t('account.credit') }}</th>
              <th class="right">
                {{ $t('account.debit') }}
              </th>
              <th>{{ $t('account.info') }}</th>
            </tr>
          </thead>
          <tbody v-if="items && items.length">
            <tr v-for="(item, i) in items" :key="`transaction${i}`">
              <td>{{ i + 1 }}</td>
              <td>{{ item.createdAt }}</td>
              <td class="right" style="color: var(--bids)">
                {{ item.credit | currency('', '₮') }}
              </td>
              <td class="right" style="color: var(--asks)">
                - {{ item.debit | currency('', '₮') }}
              </td>
              <td>{{ item.info }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">
                {{
                  $t('helper.not-found-slot', {
                    slot: $tc('account.statement', 1),
                  })
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination-nav
        class="pt-4"
        v-if="items && items.length"
        v-model="page.number"
        align="center"
        :link-gen="linkGen"
        :number-of-pages="page.totalPages || 1"
        use-router
      />
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { downloadCsvRecord } from '../../utils/functions'
import api from '../../api/balance'
import DatePicker from '../../components/DatePicker'
import moment from 'moment'

export default {
  name: 'nominalTransactionView',
  components: {
    DatePicker,
  },
  data() {
    const initial = {
      start: moment().subtract(30, 'days').toDate(),
      end: new Date(),
    }
    return {
      initialDates: initial,
      isLoading: false,
      page: {
        number: 0,
        totalPages: 1,
      },
      items: [],
      brands: [],
      filters: {
        from: moment(initial.start).format('YYYY-MM-DD'),
        to: moment(initial.end).format('YYYY-MM-DD'),
      },
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    ...mapState('common', ['dark']),
  },
  methods: {
    dateChange({ start, end }) {
      if (start && end) {
        this.filters.from = moment(start).format('YYYY-MM-DD')
        this.filters.to = moment(end).format('YYYY-MM-DD')
        this.page.number = 0
        this.totalPages = 1
      }
    },
    linkGen(page) {
      const query = { ...this.$route.query }
      if (!query.page && page === 1) {
        return { query }
      }
      query.page = page
      return { query }
    },
    async fetchData() {
      this.isLoading = true
      try {
        const { data } = await api.getTransactions(this.queryHandler(), 'tdb')
        this.page = {
          totalPages: data.totalPages,
          number: data.pageable.pageNumber + 1,
        }
        this.items = data.content
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    },
    search() {
      const query = _.pickBy(this.filters, (v) => !_.isEmpty(v) || !!v)
      this.$router.push({ query })
    },
    queryHandler() {
      this.filters = { ...this.filters, ...this.$route.query }
      return _.pickBy(this.filters, (v) => !_.isEmpty(v) || !!v)
    },
    async printTransaction() {
      const { data } = await api.getTransactionsNonPage(
        this.queryHandler(),
        'tdb'
      )
      downloadCsvRecord(
        data.content,
        ['createdAt', 'credit', 'debit', 'info'],
        'transactions',
          ['Огноо', 'Орлого', 'Зарлага', 'Гүйлгээний утга']
      )
    },
  },
  watch: {
    '$route.query': {
      handler: 'fetchData',
      deep: true,
    },
  },
}
</script>

<style scoped>
.collapse-btn {
  border-radius: 25px;
}
.collapse-btn:disabled {
  color: #5e5e5e;
  background-color: #ddd;
  border-color: #eee;
  cursor: not-allowed;
}
</style>

<style lang="scss" src="../../../sass/partials/sidebar-submenu.scss"></style>
